import {
  __, arrayof,
  data,
  e164PhoneNumber,
  isdata,
  isnull,
  isnumber,
  isoDateOnly, isoUtcDateTime,
  isstring,
  opt,
  isboolean
} from "@deckchair-technicians/vice";


@data
export class R4Patient {
  id: string = __(isstring());

  addressLine1: string = __(isstring());
  addressLine2: string = __(isstring());
  city: string = __(isstring());
  county: string = __(isstring());
  postcode: string = __(isstring());
  country: string = __(isstring());

  familyName: string = __(isstring());
  givenName: string = __(isstring());
  dateOfBirth: Date = __(isoDateOnly());

  mobileNumber: string | null = __(isstring().or(isnull()));
  emailAddress: string | null = __(isstring().or(isnull()));
}

@data
export class MedicalQuestionnaireResponse {
  questionText: string = __(isstring());
  answerText: string | null = __(isnull().or(isstring()));
  answerNotes: string | null = __(isnull().or(isstring()));
}

@data
export class R4MedicalQuestionnaire {
  submissionTime: Date = __(isoUtcDateTime());
  notes: string | null = __(isnull().or(isstring()));
  responses: MedicalQuestionnaireResponse[] = __(arrayof(isdata(MedicalQuestionnaireResponse)));
}

@data
export class R4Appointment {
  apptId: string = __(isstring());
  patientCode: string = __(isstring());
  apptDateTime: Date = __(isoDateOnly());
  status: string = __(isstring());
  statusCode: number = __(isnumber());
}

@data
export class R4ApptFlags {
  apptFlag: number = __(isnumber());
  description: string = __(isstring());
  character: Date = __(isoDateOnly());
  cancelled: boolean = __(isboolean());
}